import {html, nothing} from "lit";
import {imgPath} from "../../main/utils/common.js";

const logoPath = imgPath("powernotes-circle-logo.png");
const logoPath2x = imgPath("powernotes-circle-logo@2x.png");

export const renderPowerNotesLogo = (id?: string) => html`
	<img
		alt="PowerNotes Logo"
		id=${id ?? nothing}
		src=${logoPath}
		srcset=${`${logoPath} 1x, ${logoPath2x} 2x`}
	/>
`;
